import { apiPost } from "@/utils/apiClient";
import { API_ENDPOINTS } from "@/constants/api";
import { BrandSuggestion, Company } from "@/store/auth/types";
import { BrandRegisterResponse } from "@/store/auth/types";

export async function fetchBrandRegister(brand: Company): Promise<BrandSuggestion> {
    const response: BrandRegisterResponse = await apiPost<BrandRegisterResponse>(API_ENDPOINTS.brandRegister, {
        auth: "tokenApi",
        body: {
            input_text: brand.name
        },
    });

    return response.brand_suggestions[0];
}